/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import axios from '@axios'
import useJwt from '@/auth/jwt/useJwt'

const state = () => ({
  currentUser: {},
  loading: false,
})

const getters = {
  currentUser: state => state.currentUser,
  loading: state => state.loading,
}

const mutations = {
  setCurrentUser(state, payload) {
    state.currentUser = payload
  },
  clearCurrentUser: state => {
    state.currentUser = {}
  },
  loading: (state, payload) => {
    state.loading = payload
  },
}

const actions = {
  signIn(context, payload) {
    return new Promise((resolve, reject) => {
      context.commit('loading', true)
      axios
        .post('/v1/login', {
          auth: {
            email: payload.email.toLowerCase(),
            password: payload.password,
          },
        })
        .then(response => {
          const userData = response.data
          useJwt.setToken(userData.token)
          useJwt.setRefreshToken(userData.refresh_token)
          localStorage.setItem('userData', JSON.stringify(userData))
          context.commit('setCurrentUser', userData)
          resolve(userData)
        })
        .catch(error => reject(error))
        .finally(() => {
          context.commit('loading', false)
        })
    })
  },
  signOut(context) {
    return new Promise(resolve => {
      context.commit('clearCurrentUser')
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
      // Remove userData from localStorage
      localStorage.removeItem('userData')
      resolve()
    })
  },
  requestPassword(context, { email, redirect = true }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/v1/request_password', {
          email,
        })
        .then(response => {
          resolve(response)
          if (redirect) {
            this.$router.push('/login')
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  resetPassword(context, { token, user }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/v1/reset_password', {
          token,
          password: user.password,
          password_confirmation: user.password_confirmation,
        })
        .then(() => {
          resolve()
          this.$router.push('/')
        })
        .catch(error => {
          reject(error.response.data)
        })
    })
  },
  isLoggedIn(context) {
    if (localStorage.currentUser) {
      context.commit('setCurrentUser', JSON.parse(localStorage.currentUser))
      this.$router.push('/dashboard')
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
